import { PageShell } from "@/components/site/Site";
import { useContent } from "@/lib/api";

export default function LegalPage({ field, title }) {
  const { data, isLoading } = useContent();
  return (
    <PageShell>
      <article className="mx-auto max-w-3xl px-5 py-20 sm:px-8">
        <p className="font-mono-ui text-xs uppercase tracking-[0.3em] text-[#8B5A2B]">Namonics™</p>
        <h1 className="mt-4 font-serif-display text-4xl sm:text-5xl" data-testid="legal-title">{title}</h1>
        <div className="mt-10 whitespace-pre-line text-base leading-relaxed text-stone-700" data-testid="legal-body">
          {isLoading ? "Loading…" : data?.[field]}
        </div>
        {field !== "disclaimer" && <p className="mt-10 text-sm text-stone-500">{data?.trademark_notice}</p>}
        <p className="mt-6 text-sm text-stone-600">Questions? Write to <a className="underline" href="mailto:support@whenthetimeisripe.com">support@whenthetimeisripe.com</a></p>
      </article>
    </PageShell>
  );
}
